// LiveFocusTimer.jsx: // Page view for editing a single task in detail.
import { Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import useCurrentTime from '@/features/tasks/hooks/status/use-task-current-time.js';
import { getFocusTimerColor } from '@/features/tasks/utils/ui/focusTimerUtils.js';
import { MS_PER_MINUTE } from '@/config/constants';
import { translate as t } from '@/i18n/useT';

const LiveFocusTimer = ({
  focusStartTime,
  estimatedDuration,
  className,
  style = {},
}) => {
  const currentTime = useCurrentTime();
  const elapsedMs = currentTime.getTime() - focusStartTime;
  const elapsedMinutes = Math.max(0, Math.floor(elapsedMs / MS_PER_MINUTE));
  const color = getFocusTimerColor(elapsedMinutes, estimatedDuration);

  return (
    <Box
      component="span"
      className={className}
      style={{ ...style, color }}
      sx={{ fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' }}
      title={t('livefocustimer.title', 'Live Focus Timer')}
      data-testid="live-timer"
    >
      <AccessTimeIcon sx={{ fontSize: '14px', marginRight: '2px' }} />
      {elapsedMinutes}
      {t('common.minutesShort', 'm')}{' '}
      {estimatedDuration > 0
        ? `/ ${estimatedDuration}${t('common.minutesShort', 'm')}`
        : ''}
    </Box>
  );
};

export default LiveFocusTimer;
